import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['emailToggle', 'previewButton', 'copyLinkButton'];

  #userSendEmail = true;
  #programmaticToggle = false;
  #hasDesigns = false;
  #hasClients = false;

  rememberEmailChoice(event) {
    if (this.#programmaticToggle) {
      return;
    }
    this.#userSendEmail = event.target.checked;
  }

  selectionChanged({ detail: { hasSelection } }) {
    this.#hasDesigns = hasSelection;
    this.#applyEmailToggle(hasSelection);
    this.#applyPreviewButton();
    this.#applyCopyLinkButton(hasSelection);
  }

  clientsChanged({ detail: { hasClients } }) {
    this.#hasClients = hasClients;
    this.#applyPreviewButton();
  }

  #applyPreviewButton() {
    if (this.hasPreviewButtonTarget) {
      this.previewButtonTarget.disabled = !(this.#hasClients && this.#hasDesigns);
    }
  }

  #applyCopyLinkButton(hasSelection) {
    if (!this.hasCopyLinkButtonTarget) {
      return;
    }
    this.copyLinkButtonTarget.classList.toggle('button-disabled', !hasSelection);
  }

  #applyEmailToggle(hasSelection) {
    if (!this.hasEmailToggleTarget) {
      return;
    }

    const toggle = this.emailToggleTarget;
    const nextChecked = hasSelection ? this.#userSendEmail : false;

    if (toggle.checked !== nextChecked) {
      this.#programmaticToggle = true;
      toggle.checked = nextChecked;
      toggle.dispatchEvent(new Event('change', { bubbles: true }));
      this.#programmaticToggle = false;
    }

    toggle.disabled = !hasSelection;
  }
}
